var map = {
	"./balon.jpg": 1288,
	"./botas.jpg": 1289,
	"./camiseta.jpg": 1290,
	"./chapa.jpg": 1291,
	"./escudo-toty.jpg": 1292,
	"./escudo.jpg": 1293,
	"./estampacion.jpg": 1294,
	"./foto_a3.jpg": 1295,
	"./foto_g.jpg": 1296,
	"./foto_p.jpg": 1297,
	"./jugador.jpg": 1298,
	"./llavero.jpg": 1299,
	"./noimage.png": 117,
	"./taza.jpg": 1300
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;



//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*$
// module id = 153
// module chunks = 0